// extracted by mini-css-extract-plugin
module.exports = {"scroll":"scroll_scroll__1URtx","slide":"scroll_slide__7ZJMf","scroll__line":"scroll_scroll__line__28fkW","scrollAnim":"scroll_scrollAnim__2Qk4_"};